export const ROUTES = {
  HOME: "/",
  PORTFOLIO: "/portafolio",
  SERVICES: "/servicios",
  CONTACT: "/contacto",
  NETWORKS: "/redes",
  PROMO_250705: "/promociones/250705",
  PRIVACY: "/aviso-de-privacidad",
  PAYMENT_TERMS: "/terminos-de-pago-electronico",
};
